module.exports = __webpack_public_path__ + "static/media/control_camera_on.18868e95.svg";